/* Bloom Offers widget — build 2026-09-24.4 */
/* Bloom Offers — storefront widget (vanilla ES2020, no dependencies).
   The Liquid block paints the tier cards and a JSON config; this file only hydrates:
   selection (mouse + keyboard), per-unit variant pickers, price recompute, midnight timer,
   add-to-cart via /cart/add.js, the mobile sticky bar and analytics events. */
(function () {
  'use strict';

  // Fallback swatch colours (Hebrew option value → colour) when the metafield carries no "swatches" map.
  var SWATCH = {
    'שחור': '#000000', 'לבן': '#f4f4f4', 'קרם': '#cebba7', 'אפור': '#dedede', 'אפור כהה': '#5c5757', 'אפור בהיר': '#e4dfdf',
    'כחול': '#33396a', 'תכלת': '#96b1c2', 'כחול אוקיינוס': '#104183', 'כחול אוכמניות': '#789bdf', 'טורקיז': '#3d786c',
    'בורדו': '#71141e', 'אדום': '#cb5557', 'ורוד': '#efbaba', 'ורוד תותים': '#d89a99', 'סגול לילך': '#67365c',
    'זית': '#313a2b', 'ירוק': '#154821', 'ליים': '#dde7b0', 'חום': '#775842', 'מוקה': '#8a7473', 'קקאו': '#af7167',
    'כתום אפרסק': '#f6c194', 'לבן קוקוס': '#b1b8b8', 'קרם בננה': '#d9cebf'
  };
  var COLOR_OPTION = /^(צבע|סגנון|colou?r)$/i;

  function money(cents, format) {
    var n = (cents / 100).toFixed(2);
    var parts = n.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    return (format || '{{amount}} ₪')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, parts[0])
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/<[^>]+>/g, '');
  }

  function savingLabel(root, cents) {
    var tpl = root.getAttribute('data-saved-label') || 'חסכת #₪';
    var amount = cents % 100 === 0 ? String(cents / 100) : (cents / 100).toFixed(2);
    return tpl.replace('#', amount);
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function init(root) {
    if (root.__bo) return;
    var pid = root.getAttribute('data-product-id');
    var script = document.querySelector('script[data-bloom-offers="' + pid + '"]');
    if (!script) return;
    var cfg;
    try { cfg = JSON.parse(script.textContent); } catch (e) { root.remove(); document.documentElement.classList.remove('bo-hide-picker', 'bo-hide-buttons'); return; }
    var validTier = function (t) { return t && typeof t.id === 'string' && t.id && Number.isInteger(t.quantity) && t.quantity > 0 && Number.isInteger(t.price) && t.price >= 0 && Number.isInteger(t.compareAt) && t.price <= t.compareAt; };
    if (!cfg || cfg.v !== 1 || !Array.isArray(cfg.tiers) || !cfg.tiers.length || !cfg.tiers.every(validTier) || !Number.isInteger(cfg.unitPrice) || cfg.unitPrice <= 0) {
      // fail closed: never show a tier we cannot vouch for; restore the theme's native buy flow
      root.remove();
      document.documentElement.classList.remove('bo-hide-picker', 'bo-hide-buttons');
      return;
    }
    root.__bo = true;

    var tiers = {};
    cfg.tiers.forEach(function (t) { tiers[t.id] = t; });
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tier]'));
    var atc = root.querySelector('[data-atc]');
    var errBox = root.querySelector('[data-error]');
    var trackingUrl = root.getAttribute('data-tracking-url') || '';
    var hasOptions = cfg.options.length && !(cfg.options.length === 1 && cfg.options[0].values.length === 1 && cfg.options[0].values[0] === 'Default Title');
    var defaultVariant = cfg.variants.find(function (v) { return v.id === cfg.defaultVariantId; }) || cfg.variants[0];
    var swatches = Object.assign({}, SWATCH, cfg.swatches || {});
    var picks = {};       // tierId → [ [opt1, opt2, opt3], … ] one entry per unit row
    var selectedId = null;

    function emit(event, extra) {
      var detail = Object.assign({ event: event, productId: cfg.productId, tierId: selectedId }, extra || {});
      try { window.dispatchEvent(new CustomEvent('bloom:offer', { detail: detail })); } catch (e) { /* ignore */ }
      if (trackingUrl && navigator.sendBeacon) {
        try { navigator.sendBeacon(trackingUrl, JSON.stringify(Object.assign({ t: Date.now() }, detail))); } catch (e) { /* ignore */ }
      }
    }

    function optionValues(v) { return [v.option1, v.option2, v.option3]; }
    function findVariant(sel) {
      return cfg.variants.find(function (v) {
        var o = optionValues(v);
        return cfg.options.every(function (_, i) { return o[i] === sel[i]; });
      }) || null;
    }
    function isAvailable(sel, idx, value) {
      var probe = sel.slice(); probe[idx] = value;
      var v = findVariant(probe);
      return !!(v && v.available);
    }

    function rowsFor(tier) {
      if (!hasOptions) return 0;
      return cfg.differentVariantsEnabled ? tier.quantity : 1;
    }
    function ensurePicks(tier) {
      var n = rowsFor(tier);
      var list = picks[tier.id] || (picks[tier.id] = []);
      while (list.length < n) list.push(optionValues(defaultVariant).slice(0, cfg.options.length));
      return list;
    }

    // ---- variant pickers -------------------------------------------------------
    function renderPickers(card, tier) {
      var box = card.querySelector('[data-variants]');
      if (!box) return;
      box.innerHTML = '';
      var n = rowsFor(tier);
      if (!n) { box.hidden = true; return; }
      var list = ensurePicks(tier);
      box.appendChild(el('div', 'bo-var__names', cfg.options.map(function (o) { return o.name; }).join(', ')));
      list.forEach(function (sel, rowIdx) {
        var row = el('div', 'bo-var');
        row.setAttribute('aria-label', (root.getAttribute('data-unit-label') || '#').replace('#', String(rowIdx + 1)));
        var img = el('img', 'bo-var__img'); img.alt = ''; img.width = 30; img.height = 40;
        row.appendChild(img);
        var selects = el('div', 'bo-var__selects');
        cfg.options.forEach(function (opt, oi) {
          var useSwatch = COLOR_OPTION.test(opt.name) && opt.values.every(function (val) { return swatches[val]; });
          if (useSwatch) {
            var group = el('div', 'bo-swatches');
            group.setAttribute('role', 'radiogroup'); group.setAttribute('aria-label', opt.name);
            opt.values.forEach(function (val) {
              var b = el('button', 'bo-swatch'); b.type = 'button'; b.title = val; b.setAttribute('aria-label', val);
              b.setAttribute('role', 'radio');
              var dot = el('span', 'bo-swatch__dot'); dot.style.setProperty('--swatch', swatches[val]);
              b.appendChild(dot);
              b.addEventListener('click', function (ev) {
                ev.stopPropagation();
                sel[oi] = val; refreshRow();
              });
              group.appendChild(b);
            });
            selects.appendChild(group);
          } else {
            var s = el('select', 'bo-select'); s.setAttribute('aria-label', opt.name);
            opt.values.forEach(function (val) {
              var o = el('option', null, val); o.value = val; s.appendChild(o);
            });
            s.addEventListener('click', function (ev) { ev.stopPropagation(); });
            s.addEventListener('keydown', function (ev) { ev.stopPropagation(); });
            s.addEventListener('change', function () { sel[oi] = s.value; refreshRow(); });
            selects.appendChild(s);
          }
        });
        row.appendChild(selects);
        box.appendChild(row);

        function refreshRow() {
          var v = findVariant(sel);
          if (v && v.image) { img.src = v.image; img.hidden = false; } else if (defaultVariant.image) { img.src = defaultVariant.image; } else { img.hidden = true; }
          cfg.options.forEach(function (opt, oi) {
            var ctl = selects.children[oi];
            if (ctl.classList.contains('bo-swatches')) {
              Array.prototype.forEach.call(ctl.children, function (b) {
                var on = b.title === sel[oi];
                b.classList.toggle('bo-swatch--selected', on);
                b.setAttribute('aria-checked', on ? 'true' : 'false');
                b.classList.toggle('bo-swatch--unavailable', !isAvailable(sel, oi, b.title));
              });
            } else {
              ctl.value = sel[oi];
              Array.prototype.forEach.call(ctl.options, function (o) {
                var ok = isAvailable(sel, oi, o.value);
                o.disabled = !ok;
                o.textContent = ok ? o.value : o.value + ' — ' + (root.getAttribute('data-unavailable-label') || '');
              });
            }
          });
          updatePrices();
        }
        refreshRow();
      });
      box.hidden = false;
    }

    // ---- prices (only change if a chosen variant's price differs from the base) -------
    function computePrice(tier) {
      var list = picks[tier.id] || [];
      var prices = [];
      for (var i = 0; i < tier.quantity; i++) {
        var sel = list[cfg.differentVariantsEnabled ? i : 0];
        var v = sel ? findVariant(sel) : null;
        prices.push(v ? v.price : cfg.unitPrice);
      }
      var compare = prices.reduce(function (a, b) { return a + b; }, 0);
      var price;
      if (tier.rule === 'fixed') price = tier.price;
      else if (tier.rule === 'units') { prices.sort(function (a, b) { return b - a; }); price = prices.slice(0, tier.units).reduce(function (a, b) { return a + b; }, 0); }
      else price = compare;
      if (compare === tier.compareAt) price = tier.price; // no variant price differs: keep the Liquid-rounded value
      if (price > compare) price = compare;
      return { price: price, compare: compare, saving: compare - price };
    }
    function updatePrices() {
      cards.forEach(function (card) {
        var tier = tiers[card.getAttribute('data-tier')];
        if (!tier) return;
        var p = computePrice(tier);
        if (p.price === tier.price && p.compare === tier.compareAt) return;
        var priceEl = card.querySelector('[data-price] bdi'); if (priceEl) priceEl.textContent = money(p.price, cfg.moneyFormat);
        // The headline on a multi-unit tier is the per-item price, so it has to follow a variant change too.
        var perEl = card.querySelector('[data-peritem] bdi');
        if (perEl) {
          var pq = parseInt(card.getAttribute('data-qty'), 10) || 1;
          // Matches the Liquid's money_without_trailing_zeros so a variant change cannot reintroduce ".00".
          var per = money(Math.round(p.price / pq), cfg.moneyFormat);
          perEl.textContent = per.replace(/(\d)[.,]00(?!\d)/, '$1');
        }
        var cmpEl = card.querySelector('[data-compare] bdi'); if (cmpEl) cmpEl.textContent = money(p.compare, cfg.moneyFormat);
        var pill = card.querySelector('[data-pill]'); if (pill) pill.textContent = savingLabel(root, p.saving);
      });
    }

    // ---- selection ------------------------------------------------------------------
    function select(id, opts) {
      opts = opts || {};
      if (!tiers[id]) return;
      var changed = selectedId !== id;
      selectedId = id;
      cards.forEach(function (card) {
        var on = card.getAttribute('data-tier') === id;
        card.classList.toggle('bo-tier--selected', on);
        card.setAttribute('aria-checked', on ? 'true' : 'false');
        card.tabIndex = on ? 0 : -1;
        var box = card.querySelector('[data-variants]');
        if (on) renderPickers(card, tiers[id]);
        else if (box) { box.hidden = true; box.innerHTML = ''; }
      });
      showError('');
      if (opts.focus) { var c = cards.find(function (x) { return x.getAttribute('data-tier') === id; }); if (c) c.focus(); }
      if (changed && !opts.silent) emit('select');
    }

    cards.forEach(function (card, idx) {
      card.addEventListener('click', function () { select(card.getAttribute('data-tier')); });
      card.addEventListener('keydown', function (ev) {
        if (ev.target !== card) return;
        var next = null;
        if (ev.key === 'ArrowDown' || ev.key === 'ArrowLeft') next = (idx + 1) % cards.length;
        else if (ev.key === 'ArrowUp' || ev.key === 'ArrowRight') next = (idx - 1 + cards.length) % cards.length;
        else if (ev.key === ' ' || ev.key === 'Enter') next = idx;
        else return;
        ev.preventDefault();
        select(cards[next].getAttribute('data-tier'), { focus: true });
      });
    });

    // ---- add to cart ------------------------------------------------------------------
    function showError(msg) {
      if (!errBox) return;
      errBox.textContent = msg || '';
      errBox.hidden = !msg;
    }
    function buildItems() {
      var tier = tiers[selectedId];
      var counts = {};
      var order = [];
      var list = picks[tier.id] || [];
      for (var i = 0; i < tier.quantity; i++) {
        var sel = hasOptions ? list[cfg.differentVariantsEnabled ? i : 0] : null;
        var v = sel ? findVariant(sel) : defaultVariant;
        if (!v || !v.available) return null;
        if (!counts[v.id]) { counts[v.id] = 0; order.push(v.id); }
        counts[v.id]++;
      }
      var items = order.map(function (id) { return { id: id, quantity: counts[id], properties: { _bloom_tier: tier.id } }; });
      (tier.gifts || []).forEach(function (g) {
        items.push({ id: g.variantId, quantity: g.quantity || 1, properties: { _bloom_gift: String(cfg.productId) } });
      });
      return items;
    }
    // Where to go after adding. In "code" execution mode the tier's discount codes are applied on the way
    // (/discount/CODE?redirect=...), so checkout honours the tier without touching the live store's automatic discounts.
    // Applies the tier's discount codes through the Cart API and VERIFIES they took (fail closed).
    // Existing codes in the cart (other bundles) are preserved. Resolves true only when every code is applicable.
    function applyCodes(tierId) {
      var ex = cfg.execution;
      var codes = ex && ex.type === 'code' && ex.codes && ex.codes[tierId];
      if (!codes || !codes.length) return Promise.resolve(true);
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        // keep only codes that still apply (a stale code from an earlier visit makes the whole update fail)
        var existing = (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
        var merged = existing.slice();
        codes.forEach(function (c) { if (merged.indexOf(c) < 0) merged.push(c); });
        var post = function (list) {
          return fetch('/cart/update.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: list.join(',') })
          }).then(function (r) { return r.ok ? r.json() : null; });
        };
        return post(merged).then(function (updated) { return updated || post(codes); }).then(function (updated) {
          var applied = (updated && updated.discount_codes) || [];
          return codes.every(function (c) { return applied.some(function (a) { return a.code === c && a.applicable; }); });
        });
      }).catch(function () { return false; });
    }
    // Removes exactly the units this widget just added (never the customer's earlier lines).
    // Works on the line keys Shopify returned from /cart/add.js: a variant id is ambiguous once lines carry properties.
    function undoAdd(added) {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        return added.reduce(function (p, it) {
          return p.then(function () {
            var line = (cart.items || []).filter(function (l) { return l.key === it.key; })[0];
            if (!line) return null;
            var q = Math.max(0, line.quantity - it.quantity);
            return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: it.key, quantity: q }) });
          });
        }, Promise.resolve());
      }).catch(function () {});
    }
    // Behave like the theme's own add-to-cart: refresh + open its cart drawer (Dawn-style <cart-drawer>).
    // Falls back to the cart page when the theme has no drawer.
    function openCartDrawer(added) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') { window.location.href = '/cart'; return; }
      var ids = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      // sections are fetched AFTER the codes are applied so the drawer shows the bundle price; the payload mirrors
      // the /cart/add.js response the theme's own product form hands to renderContents
      // no Accept: application/json here — Shopify then answers with the cart JSON instead of the sections
      return fetch('/cart?sections=' + encodeURIComponent(ids) + '&t=' + Date.now())
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var first = added && added[0];
          drawer.renderContents({ items: added || [], key: first && first.key, id: first && first.id, sections: sections });
        })
        .catch(function () { window.location.href = '/cart'; });
    }
    function addToCart() {
      var items = buildItems();
      if (!items) { showError(root.getAttribute('data-unavailable-label') || 'Unavailable'); return; }
      var label = atc.textContent;
      atc.disabled = true; atc.textContent = root.getAttribute('data-adding-label') || label;
      showError('');
      emit('add_to_cart', { items: items.map(function (i) { return { id: i.id, quantity: i.quantity }; }) });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        return res.json().then(function (body) { return { ok: res.ok, body: body }; });
      }).then(function (r) {
        if (!r.ok) throw new Error(r.body && (r.body.description || r.body.message) || 'error');
        var added = ((r.body && r.body.items) || []).map(function (l) { return { key: l.key, id: l.id, quantity: l.quantity }; });
        return applyCodes(selectedId).then(function (ok) {
          if (!ok) {
            // checkout would not honour the promised price: take the units back out and say so
            return undoAdd(added).then(function () { throw new Error(root.getAttribute('data-discount-error-label') || root.getAttribute('data-error-label') || 'Error'); });
          }
          atc.disabled = false; atc.textContent = label;
          if (!root.hasAttribute('data-no-redirect')) return openCartDrawer(added);
        });
      }).catch(function (e) {
        atc.disabled = false; atc.textContent = label;
        showError(e && e.message !== 'error' && e.message || root.getAttribute('data-error-label') || 'Error');
      });
    }
    if (atc) atc.addEventListener('click', addToCart);

    // ---- timer (until local midnight) ---------------------------------------------------
    var timerVal = root.querySelector('[data-timer-value]');
    if (timerVal) {
      // A real deadline when the offer carries `endsAt`, otherwise the old countdown to local midnight.
      // Once a real deadline passes the whole timer is removed rather than left sitting at 00:00:00 —
      // a stopped clock is worse than no clock.
      var fixedEnd = null;
      if (cfg.endsAt) { var parsed = new Date(cfg.endsAt); if (!isNaN(parsed)) fixedEnd = parsed; }
      var timerBox = root.querySelector('[data-timer]');
      var timerId = null;
      var tick = function () {
        var now = new Date();
        var end = fixedEnd;
        if (!end) { end = new Date(now); end.setHours(24, 0, 0, 0); }
        var s = Math.floor((end - now) / 1000);
        if (fixedEnd && s <= 0) {
          if (timerBox) timerBox.hidden = true;
          if (timerId) clearInterval(timerId);
          return;
        }
        s = Math.max(0, s);
        var pad = function (n) { return (n < 10 ? '0' : '') + n; };
        var d = Math.floor(s / 86400), h = Math.floor(s / 3600) % 24;
        timerVal.textContent = (d > 0 ? d + ':' : '') + pad(d > 0 ? h : Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
      };
      tick(); timerId = setInterval(tick, 1000);
    }

    // ---- sticky bar (mobile) -------------------------------------------------------------
    if (root.getAttribute('data-sticky') === 'true' && 'IntersectionObserver' in window) {
      var bar = el('div', 'bo-sticky');
      var content = el('div', 'bo-sticky__content');
      if (cfg.productImage) { var im = el('img', 'bo-sticky__img'); im.src = cfg.productImage; im.alt = ''; content.appendChild(im); }
      content.appendChild(el('div', 'bo-sticky__title', cfg.productTitle));
      var btn = el('button', 'bo-sticky__btn', root.getAttribute('data-sticky-label') || 'Choose'); btn.type = 'button';
      btn.addEventListener('click', function () { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      bar.appendChild(content); bar.appendChild(btn);
      document.body.appendChild(bar);
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('bo-sticky--visible', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(root);
    }

    // ---- boot ---------------------------------------------------------------------------
    var initial = cards.find(function (c) { return c.classList.contains('bo-tier--selected'); });
    select(initial ? initial.getAttribute('data-tier') : (cfg.preselectedTierId || cfg.tiers[0].id), { silent: true });
    emit('view');
  }

  function boot() {
    var roots = document.querySelectorAll('[data-bloom-offers-root]');
    if (!roots.length) {
      // The embed hid the theme's picker before paint; no block on this page → give it back. Never block a sale.
      document.documentElement.classList.remove('bo-hide-picker', 'bo-hide-buttons');
      return;
    }
    Array.prototype.forEach.call(roots, init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Theme editor re-renders sections: hydrate again.
  document.addEventListener('shopify:section:load', boot);
})();
